export const mulipleExpertSelect = (fontWeight: string) => ({
  "& p": { fontSize: "14px", fontWeight },
});
